import { css } from '@emotion/react/macro';
import styled from '@emotion/styled/macro';
import { BaseButton, Variables } from '@enter/core';

export const FormWrapper = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 14px 24px 14px;
`;

export const FieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;
    padding: 0 10px;
`;

export const StepperActionsSide = styled.div`
    button:nth-of-type(2) {
        margin-left: 16px;
    }
`;

export const StepperWrapper = styled.div`
    padding: 0 10px;
`;

export const StepperActions = styled.section`
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    ${StepperActionsSide} {
        &:not(:first-of-type) {
            margin-left: 16px;
        }
    }
`;

export const FormButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;

export const SummaryStep = styled.section`
    margin: 24px 0;
`;

export const SummaryStepHeader = styled.section`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${Variables.Colors.platinum};
`;

export const SummaryStepTitle = styled.div`
    color: ${Variables.Colors.n100};
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
`;

export const SummaryGroupLabel = styled.div`
    font-size: 18px;
    color: ${Variables.Colors.n70};
    margin-top: 24px;
`;

export const SummaryGroupText = styled.div`
    font-size: 16px;
    line-height: 1.25;
    color: ${Variables.Colors.n100};
    margin-top: 8px;
`;

export const Amount = styled.div``;
export const Currency = styled.div``;

export const AmountField = styled.div`
    display: flex;
`;

export const EmptyValue = styled.span`
    color: ${Variables.Colors.n15};
`;

export const DeleteButton = styled(BaseButton)`
    width: 18px;
    height: 18px;
    padding: 0;
    min-width: auto;
`;

export const Spacer = styled.div`
    height: 1px;
    width: 100%;
    background-color: ${Variables.Colors.platinum};
    margin-bottom: 16px;
`;

export const SpacerContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    ${DeleteButton} {
        position: absolute;
        top: 0;
        right: 16px;
        transform: translateY(-50%);
    }
`;

export const StepperActionsSideLeft = styled(StepperActionsSide)``;
export const StepperActionsSideRight = styled(StepperActionsSide)``;

export const ListWrapper = styled.div<{ maxHeight?: number }>`
    ${({ maxHeight }) =>
        maxHeight
            ? css`
                  max-height: ${maxHeight}px;
                  overflow-y: auto;
              `
            : undefined}
`;
